import { render, staticRenderFns } from "./ControleFinanceiro.vue?vue&type=template&id=438d7060&"
import script from "./ControleFinanceiro.vue?vue&type=script&lang=ts&"
export * from "./ControleFinanceiro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports